// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner-module--Spinner--q7ZQu","Img":"Spinner-module--Img--dY2Hp"};